import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { BannerRequest } from '../api/banner/getbanner/bannerrequest';
import { BannerResponse, BannerResponseDtoImpl } from '../api/banner/getbanner/bannerresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { BannerBuilder } from '../dto/banner/bannerbuilder';
import { Logger, LogManager } from '../../utils/logger/logger';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class BannerAPIProcessorImpl extends APIProcessorImpl<BannerRequest, BannerResponse>
{
    private LOGGER: Logger = LogManager.getLogger(BannerAPIProcessorImpl.name);
    execute(request: BannerRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);

        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new BannerResponseDtoImpl(APIFeatures.BANNER, "Get Banner Success");
                let bannerDetailsResponse = new BannerBuilder(responseMapper.getResponseMap()).buildAll();

                response.setBannerDto(bannerDetailsResponse);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new BannerResponseDtoImpl(APIFeatures.BANNER, "No Banner Data Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new BannerResponseDtoImpl(APIFeatures.BANNER, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new BannerResponseDtoImpl(APIFeatures.BANNER, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
  
            this.getAPIFailure(new BannerResponseDtoImpl(APIFeatures.BANNER, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/bannerapiprocessor.tsx